import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css'; // Swiper 스타일 임포트
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';

const Games = () => {
  const [gameList, setGameList] = useState([]);

  useEffect(() => {
    const fetchGames = async () => {
      try {
        const response = await axios.get('https://www.plassion.co.kr:8444/api/get/games_board_list', {
          params: {
            cate: 'games',
          },
        });
        setGameList(response.data.data);
      } catch (error) {
        console.error('Error fetching games data:', error);
      }
    };
    fetchGames();
  }, []);

  const handleStoreLink = (idx) => {
    const game = gameList.find((g) => g.idx === idx);
    if (game && game.store_link) {
      console.log('Opening link:', game.store_link); // 로그 추가
      window.open(game.store_link, '_blank');
    } else {
      alert('구글플레이 준비중입니다.');
    }
  };

  return (
    <div className="games-wrap">
      <div className="games-intro-title">즐거움과 기술의 조화로 완성되는 플레이션의 게임</div>
      <div className="games-grid">
        {gameList.map((game, index) => (
          <div className="games-box" key={index}>
            <div className="content-and-image">
              {window.innerWidth <= 1350 ? ( // 1300px 이하 조건
                <>
                  <SwiperComponent game={game} />
                  <div className="games-content">
                    {game.icon ? (
                      <img
                        style={{ width: '80px', height: '70px', borderRadius: '18px' }}
                        src={`https://www.plassion.co.kr:8444/${game.icon}`}
                        alt={`${game.title}`}
                      />
                    ) : null}
                    <p className="games1-genre">{game.genre}</p>
                    <p className="games1-title">{game.title}</p>
                    <p className="games1-sub-title">{game.sub_title}</p>
                    <p className="games1-content">{game.content.replace(/<[^>]+>/g, '')}</p>
                    <div className="store-wrap">
                      <div className="google-play" onClick={() => handleStoreLink(game.idx)}>
                        {' '}
                      </div>
                      {/* <div className="app-store"></div> */}
                    </div>
                  </div>
                </>
              ) : index % 2 === 0 ? ( // 1300px 이상 조건
                <>
                  {/* 오른쪽 이미지 */}
                  <div className="games-content">
                    {game.icon ? (
                      <img
                        className="games-img-left"
                        style={{ width: '80px', height: '70px', borderRadius: '18px' }}
                        src={`https://www.plassion.co.kr:8444/${game.icon}`}
                        alt={`${game.title}`}
                      />
                    ) : null}
                    <p className="games1-genre">{game.genre}</p>
                    <p className="games1-title">{game.title}</p>
                    <p className="games1-sub-title">{game.sub_title}</p>
                    <p className="games1-content" dangerouslySetInnerHTML={{ __html: game.content }}></p>
                    <div className="store-wrap">
                      <div className="google-play" onClick={() => handleStoreLink(game.idx)}>
                        {' '}
                      </div>
                      {/* <div className="app-store"></div> */}
                    </div>
                  </div>
                  <SwiperComponent game={game} />
                </>
              ) : (
                <>
                  {/* 왼쪽 이미지 */}
                  <SwiperComponent game={game} />
                  <div className="games-content right">
                    <div className="games-content-inner-right">
                      {game.icon ? (
                        <img
                          className="games-img-right"
                          src={`https://www.plassion.co.kr:8444/${game.icon}`}
                          alt={`${game.title}`}
                        />
                      ) : null}
                    </div>
                    <p className="games1-genre">{game.genre}</p>
                    <p className="games1-title">{game.title}</p>
                    <p className="games1-sub-title">{game.sub_title}</p>
                    <p className="games1-content">{game.content.replace(/<[^>]+>/g, '')}</p>
                    <div className="store-wrap">
                      <div className="google-play right" onClick={() => handleStoreLink(game.idx)}>
                        {' '}
                      </div>
                      {/* <div className="app-store right"></div> */}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const SwiperComponent = ({ game }) => (
  <div className="image-container">
    <Swiper
      modules={[Pagination, Scrollbar, A11y, Autoplay]}
      slidesPerView={1}
      pagination={{ clickable: true }}
      scrollbar={{ draggable: true }}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      speed={800}
    >
      {/* img1 ~ img5까지 반복 */}
      {Array.from({ length: 5 }, (_, i) =>
        game[`img${i + 1}`] ? (
          <SwiperSlide key={i}>
            <img src={`https://www.plassion.co.kr:8444/${game[`img${i + 1}`]}`} alt={`${game.title} 이미지 ${i + 1}`} />
          </SwiperSlide>
        ) : null
      )}
    </Swiper>
    <div className="games-hover">
      <p>상세보기</p>
    </div>
  </div>
);

export default Games;
